// extracted by mini-css-extract-plugin
export default {"nav":"AdminCommon_nav__mGHJ0","navLink":"AdminCommon_navLink__4AAiz","navLinkActive":"AdminCommon_navLinkActive__zBgno","versionFooter":"AdminCommon_versionFooter__tAtSM"};